import { isPresent } from '../../utils/isPresent';
import { React, Fragment, useState, useRef } from "react";
import ResponsiveMasonry from "react-masonry-css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faChevronDown, faCheck } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/free-solid-svg-icons";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { Menu, Dialog, Transition } from "@headlessui/react";
import NewSingleCard from "./NewSingleCard";
import "../SingleBucket";
import axios from "axios";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BlackDismiss from "../../assets/icons/dismissButton.svg";
import ShareCard from "./shareCard";
import moment from "moment";
import "../../components/Files/Files.scss";
// import {ReactComponent as CalenderIcon} from "../../assets/icons/calendarIcon.svg";

import { useOutletContext } from "react-router-dom";
import CreateBucket from "../CreateBucket";
import EditIcon from "../../assets/icons/edit.svg";
import CalenderIcon from "../../assets/icons/calendar.svg";


import ThreeDots from "../../assets/icons/threeDots.svg";
import Arrow from "../../assets/icons/arrow.svg";


















// import { ReactComponent as MySVG } from "../../assets/icons/go_pointer_top_icon.svg";
// import { ReactComponent as MySVG } from "../../assets/icons/7601886_top_arrow.svg";
import { ReactComponent as MySVG } from "../../assets/icons/7601886_top_arrow-update.svg";
// import { ReactComponent as MySVG } from '../../assets/icons/7601886_top_arrow-1.svg';
import { toastify } from "../../components/Toast";
import { ToastContainer } from "react-toastify";
import DismissButton from "../../assets/icons/subbcuketsbackarrow.svg";
import PopUpClose from "../../assets/icons/orangedismiss.svg";
import "react-toastify/dist/ReactToastify.css";
import "../../components/Bookmarks/Bookmarks.scss";








import FilesSub from "../../assets/icons/subfilesorange.svg";



import NewBookmarksSub from "../../assets/icons/newBookmarksIcon.svg";
import "../../components/Bookmark List/bookmarklist";

import SortMbl from "../../assets/icons/sortmbl.svg";
import ScrollToTop from "react-scroll-to-top";
import "../../components/Bookmarks/Bookmarks";
import BookmarksPopup from "../../components/BookmarksPopup/BookmarksPopup";
import CustomizePopup from "../../shades/cards/popupfinal";
import ShareBucket from "./ShareBucket";
import FilesPopup from "../../components/FilesPopup/FilesPopup";
import MoveModal from "./includes/MoveModal";
import "./BucketInner.css";
import { Eye, EyeOff, Search, X } from "lucide-react";
import { CardSkeletonGrid } from "./CardSkeleton";
const cardGridBreakpoints = {
  default: 5,
  1535: 4,
  1279: 3,
  1023: 2,
  767: 1,
};

function BucketInner(props) {
  const navigate = useNavigate();
  const [subBucket, setSubBucket] = useState([]);
  const [cardList, setCardList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [popup, setPopup] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);
  const [bucketCreated, setBucketCreated] = useState(false);
  const [cardCreated, setCardCreated] = useState(false);
  const [bucketOperation, setBucketOperation] = useState("Add");
  const [selectedItems, setSelectedItems] = useState([]);
  const [bucketNameText, setBucketNameText] = useState("");
  const [bucketUpdateId, ] = useState(0);
  const [BucketSharePopup, setBucketSharePopup] = useState(false);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const MainbucketId = urlSearchParams.get("bucketId");
  const MainbucketName = urlSearchParams.get("name");
  const [CardSharePopup, setCardSharePopup] = useState(false);
  const [shareBucketId, setShareBucketId] = useState("");
  const [shareCardId, setShareCardId] = useState("");
  useState(false);
  let [isOpenss, setIsOpens] = useState(false);
  useOutletContext();
  const [cardTitle, setCardTitle] = useState("");
  useState(true);
  useState(true);
  useState(false);
  useState(true);
  useState(false);
  useState(false);
  const [filepopup, setFilePopup] = useState(false);
  const [Custompopup, setCustomPopup] = useState(false);
  const [filepopupAnimation, setFilePopupAnimation] = useState(false);
  const [bookmarkpopupAnimation, setBookmarkPopupAnimation] = useState(false);
  const [bookmarkpopup, setBookmarkPopup] = useState(false);
  const fileDrawerTimer = useRef(null);
  const bookmarkDrawerTimer = useRef(null);
  const fileDrawerFrame = useRef(null);
  const bookmarkDrawerFrame = useRef(null);
  useEffect(() => () => {
    clearTimeout(fileDrawerTimer.current);
    clearTimeout(bookmarkDrawerTimer.current);
    cancelAnimationFrame(fileDrawerFrame.current);
    cancelAnimationFrame(bookmarkDrawerFrame.current);
  }, []);
  useEffect(() => {
    if (!filepopup && !bookmarkpopup) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = previousOverflow; };
  }, [filepopup, bookmarkpopup]);
  useEffect(() => {
    if (!filepopup && !bookmarkpopup) return undefined;
    const closeOnEscape = (event) => {
      if (event.key !== "Escape") return;
      if (bookmarkpopup) {
        clearTimeout(bookmarkDrawerTimer.current);
        setBookmarkPopupAnimation(false);
        bookmarkDrawerTimer.current = setTimeout(() => setBookmarkPopup(false), 280);
      } else {
        clearTimeout(fileDrawerTimer.current);
        setFilePopupAnimation(false);
        fileDrawerTimer.current = setTimeout(() => setFilePopup(false), 280);
      }
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [filepopup, bookmarkpopup]);
  useState(false);
  useState(true);
  useState(true);
  useState(false);
  useState(false);
  useState(false);
  useState(true);
  const [titleState, setTitleState] = useState(true);
  useState(false);
  const [selectedBucketName, ] = useState("");
  const [selectedBucketId, ] = useState("");
  useState([]);
  useRef(null);
  useState(false);
  const [lastList, setLastList] = useState(false);
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [buckets, setBuckets] = useState([]);
  const [totalCards, setTotalCards] = useState(0);
  const [bookmarkPopupCount, setBookmarkPopupCount] = useState(0);
  const [filePopupCount, setFilePopupCount] = useState(0);
  const [SharedToken, setSharedToken] = useState("");
  const [openMove, setOpenMove] = useState(false);
  const [PermissionState, setPermissionState] = useState("");
  const [moveModal, setMoveModal] = useState(false)
  useState(true);
  const [appTheme, setAppTheme] = useState("");
  const [openCopyLink, setOpenCopyLink] = useState(false);
  const [publicUrl, setPublicUrl] = useState("");
  const [showCopy, setShowCopy] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [iOS, ] = useState(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);

  // Platform and Format filter states
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const [selectedFormats, setSelectedFormats] = useState([]);
  const [showPlatformFilter, setShowPlatformFilter] = useState(false);
  const [showFormatFilter, setShowFormatFilter] = useState(false);

  // Platform and Format filter options
  const platformOptions = [
    { name: "Instagram", value: "instagram" },
    { name: "Facebook", value: "facebook" },
    { name: "TikTok", value: "TikTok" },
    { name: "Twitter", value: "twitter" },
    { name: "YouTube", value: "youtube" }
  ];

  const formatOptions = [
    { name: "Video", value: "Video" },
    { name: "Image", value: "Image" },
    { name: "Carousel", value: "Carousel" }
  ];



  useEffect(() => {
    const handleStorageChange = () => {
      const theme = localStorage.getItem("theme");
      setAppTheme(theme);
    };

    window.addEventListener('storage', handleStorageChange);

    // Force a re-render when localStorage changes
    setAppTheme(localStorage.getItem("theme"));

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  useEffect(() => {
    // Function to fetch data from the API and update the state
    const token = localStorage.getItem("token");
    const fetchBuckets = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}buckets/user-buckets`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        ); // Replace this with the actual API endpoint
        setBuckets(response?.data?.data?.bucketList); // Assuming the API response is an array of bucket objects
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (token) {
      fetchBuckets();
    }
  }, [bucketCreated]);
  const closeSharePop = () => {
    setBucketSharePopup(false);
  };
  const bucketPublicShare = (url) => {
    if (iOS) {
      setOpenCopyLink(true);
      setPublicUrl(url);
    } else {
      const tempInput = document.createElement("input");
      tempInput.value = url;

      // Append the input element to the DOM
      document.body.appendChild(tempInput);

      // Select the input element's text and copy it to clipboard
      tempInput.select();
      document.execCommand("copy");

      // Remove the temporary input element
      document.body.removeChild(tempInput);

      toastify("success", "Public link is copied to clipboard");
    }
  }
  const closeCopyLinkModal = () => {
    setOpenCopyLink(false);
  }
  const handleCopyText = (url) => {
    var emailLink = document.querySelector('.publicUrlInput');
    emailLink.select();
    var range = document.createRange();
    range.selectNode(emailLink);
    window.getSelection().addRange(range);

    try {
      // Now that we've selected the anchor text, execute the copy command  
      document.execCommand('copy');
      toastify("success", "Public link is copied to clipboard");
    } catch (err) {
      console.error('Oops, unable to copy');
      toastify("success", 'Oops, unable to copy');
    }

    // Remove the selections - NOTE: Should use
    // removeRange(range) when it is supported  
    window.getSelection().removeAllRanges();
    setOpenCopyLink(false);
    // setTimeout(() => {
    //   bucketUpdate();
    // }, 1000);
  }
  const MoveCard = async () => {
    setMoveModal(true)
    setOpenMove(true);
  };

  const closeMove = () => {
    // setIsBucketOpen(false);
    // setSelectedItems("")
    setSelectedItems([])
    setMoveModal(false)
    setOpenMove(false);
    // setselectedBucketId("");
    // setSearchBucket("");
  };
  const closeCardSharePop = () => {
    setCardSharePopup(false);
  };
  const closeCustomPopup = () => {
    setCustomPopup(false);
  };













  const handleFilePopup = () => {
    clearTimeout(fileDrawerTimer.current);
    setFilePopup(true);
    fileDrawerFrame.current = requestAnimationFrame(() => setFilePopupAnimation(true));
  };

  function closeFilePopup() {
    cancelAnimationFrame(fileDrawerFrame.current);
    clearTimeout(fileDrawerTimer.current);
    setFilePopupAnimation(false);
    fileDrawerTimer.current = setTimeout(() => {
      setFilePopup(false);
    }, 280);
  }

  const handleBookmarkPopup = () => {
    clearTimeout(bookmarkDrawerTimer.current);
    setBookmarkPopup(true);
    bookmarkDrawerFrame.current = requestAnimationFrame(() => setBookmarkPopupAnimation(true));
  };

  function closeBookmarkPopup() {
    cancelAnimationFrame(bookmarkDrawerFrame.current);
    clearTimeout(bookmarkDrawerTimer.current);
    setBookmarkPopupAnimation(false);
    bookmarkDrawerTimer.current = setTimeout(() => {
      setBookmarkPopup(false);
    }, 280);
  }
























  const bucketId = useParams();


  function closeCardModal() {
    // setSelectedItems([]);
    setIsOpens(false);
  }

  const filterFilesDropDown = [
    { name: "File Name", href: "#" },
    { name: "Bucket Name", href: "#" },
    { name: "Upload Date", href: "#" },
    { name: "Size", href: "#" },
  ];

  useState(filterFilesDropDown[0].name);



  const filterDropDown = [
    { name: "Created Date", href: "#" },
    { name: "Recent Activity", href: "#" },
    { name: "Ascending Order", href: "#" },
    { name: "Descending Order", href: "#" },
    // { name: 'Manual', href: '#' },
  ];

  let cardFilterv = "";
  if (!localStorage.getItem("cardFilter")) {
    localStorage.setItem("cardFilter", "Created_Date");
    cardFilterv = "Created_Date";
  } else {
    cardFilterv = localStorage.getItem("cardFilter");
  }
  const [cardFilterDefault, setCardFilterDefault] = useState(cardFilterv);
  useEffect(() => {
    // This request belongs to the current route/filter; ignore responses after cleanup.
    let active = true;

    const fetchData = async () => {
      const token = localStorage.getItem("token");
      // setIsLoadings(true)
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}cards/cardList-by-bucketId`,
          {
            bucketId: `${bucketId.id}`,
            filterValue: cardFilterDefault,
            page: 1,
            limit: 1,
            type: "BookMark",
            tagId: "",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!active) return;
        setBookmarkPopupCount(response?.data?.data?.totalCards);
        // setIsLoadings(false)
      } catch (error) {
        console.error(error);
      }
    };
    const fetchDatas = async () => {
      const token = localStorage.getItem("token");
      // setIsLoadings(true)
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}cards/cardList-by-bucketId`,
          {
            bucketId: `${bucketId.id}`,
            filterValue: cardFilterDefault,
            page: 1,
            limit: 1,
            type: "File",
            tagId: "",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!active) return;
        setFilePopupCount(response?.data?.data?.totalCards);
        // setIsLoadings(false)
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
    fetchDatas();

    return () => { active = false; };
  }, [bucketId.id, cardFilterDefault, navigate]);
  useEffect(() => {
    // This request belongs to the current route/filter; ignore responses after cleanup.
    let active = true;

    // api url
    const urlSearchParams = new URLSearchParams(window.location.search);
    const bookmarkpopup = urlSearchParams.get("bookmarkpopup");
    const shared = urlSearchParams.get("shared");
    const permission = urlSearchParams.get("permission");
    if (shared === "true") {
      setSharedToken(true);
    }
    if (permission) {
      setPermissionState(permission);
    }
    // bookmarkpopup == 1 ? setBookmarkPopup(true) : "";
    if (bookmarkpopup) {
      setBookmarkPopup(true);
    }

    const filepopups = urlSearchParams.get("filepopup");
    if (filepopups) {
      setFilePopup(true);
    }
    const token = localStorage.getItem("token");

    axios
      .get(`${process.env.REACT_APP_API}buckets/single/${bucketId.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
          if (!active) return;
        setIsLoading(false);
        setSubBucket(response?.data?.data);
      })
      .catch(function (error) {
          if (!active) return;
        console.error(error);
      });
    const fetchData = async () => {
      setIsLoadings(true);
      axios
        .post(
          `${process.env.REACT_APP_API}cards/cardList-by-bucketId`,
          {
            bucketId: `${bucketId.id}`,
            filterValue: cardFilterDefault,
            page: currPage,
            limit: 8,
            type: "Card",
            "platform": selectedPlatforms,
            "format": selectedFormats,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(function (response) {
          if (!active) return;
          setIsLoading(false);
          if (!response.data.data.cardsList.length) {
            setLastList(true);
            setIsLoadings(false);
            return;
          }
          setPrevPage(currPage);
          // setUserList([...userList, ...response.data.data]);
          setCardList(current => [...current, ...response.data.data.cardsList]);
          setTotalCards(response.data.data.totalCards);
          setIsLoadings(false);
        })
        .catch(function (error) {
          if (!active) return;
          console.error(error);
          if (error?.response?.data?.statusCode) {
            if ((error?.response?.data?.statusCode === 404 || error?.response?.data?.statusCode === "404")) {
              navigate(`/notFound`)
            }
          }
        });
    };
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;
      if (
        parseInt(scrollTop) + parseInt(clientHeight) ===
        parseInt(scrollHeight)
      ) {
        setCurrPage(currPage + 1);
      }
    };

    if (!lastList && prevPage !== currPage) {
      fetchData();
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      active = false;
      window.removeEventListener("scroll", handleScroll);
    };
  }, [bucketCreated, cardCreated, currPage, lastList, prevPage, selectedPlatforms, selectedFormats, bucketId.id, cardFilterDefault, navigate]);



  function changeTxt(event) {
    setBucketNameText(event.target.value);
  }




  const handleCardTitle = () => {
    const token = localStorage.getItem("token");
    try {
      const response = axios.patch(`${process.env.REACT_APP_API}buckets/update`, { bucketId: bucketId.id, name: cardTitle },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response) {
        setTitleState(true);
        bucketUpdate();
      }
    } catch (error) {
      console.error(error);
    }
  };



  const handleSharePop = (id) => {
    setShareBucketId(id);
    setBucketSharePopup(true);
  };
  const handleCardSharePop = (id) => {
    setShareCardId(id);
    setCardSharePopup(true);
  };
  // const [filtersText, setFiltersText] = useState(filterDropDown[0].name);
  const [filtersText, setFiltersText] = useState(
    cardFilterv === "Created_Date"
      ? filterDropDown[0].name
      : cardFilterv === "Descending_Order"
        ? filterDropDown[3].name
        : cardFilterv === "Ascending_Order"
          ? filterDropDown[2].name
          : cardFilterv === "Recent_Activity"
            ? filterDropDown[1].name
            : ""
  );

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.includes(value)
          ? prevSelectedItems
          : [...prevSelectedItems, value]
      );
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((item) => item !== value)
      );
    }
  };

  const deleteCard = async () => {
    setIsOpens(true);
  };

  const handleDeleteCard = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API}cards/delete`,
        {
          data: { deletedIds: selectedItems },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toastify("success", response.data.message);
      setSelectedItems([]);
      closeCardModal();
      cardUpdate();
    } catch (error) {
      console.error(error);
      closeCardModal();
      setIsLoading(false);
      toastify("error", error.response.data.message);
    }
  };

  const handleCardClick = (text) => {
    if (text === "Select All") {
      setSelectedItems(cardList.map((card) => card._id));
    } else if (text === "Unselect All") {
      setSelectedItems([]);
    }
  };

  const handleFilterText = (text) => {
    // setFiltersText(text);
    setIsLoading(true);
    setFiltersText(text);
    const filterValues =
      text === "Created Date"
        ? "Created_Date"
        : text === "Descending Order"
          ? "Descending_Order"
          : text === "Ascending Order"
            ? "Ascending_Order"
            : text === "Recent Activity"
              ? "Recent_Activity"
              : "";
    localStorage.setItem("cardFilter", filterValues);
    setCardFilterDefault(filterValues);
    localStorage.getItem("token");
    cardUpdate();
    // axios.post(`${process.env.REACT_APP_API}cards/cardList-by-bucketId`, {
    //     bucketId:`${bucketId.id}`,
    //     filterValue:filterValues,

    //   },{
    //     headers: {
    //     Authorization: `Bearer ${token}`,
    //   }
    //   })
    //   .then(function (response) {
    //     setIsLoading(false);
    //     // setCardList(response.data.data);
    //     setCardList(response.data.data.cardsList);
    //     setTotalCards(response.data.data.totalCards);
    //     // reorder(response.data.data);
    //     // setBucketList(response.data.data.bucketList);
    //     // setTotalBuckets(response.data.data.total);
    //   })
    // .catch(function (error) {
    // });
  };





  // Platform filter handlers
  const handlePlatformChange = (platformValue) => {
    setSelectedPlatforms(prev => {
      if (prev.includes(platformValue)) {
        return prev.filter(p => p !== platformValue);
      } else {
        return [...prev, platformValue];
      }
    });
    cardUpdate();
  };

  const handleSelectAllPlatforms = () => {
    setSelectedPlatforms(platformOptions.map(p => p.value));
    cardUpdate();
  };

  const handleUnselectAllPlatforms = () => {
    setSelectedPlatforms([]);
    cardUpdate();
  };

  const handlePlatformFilterClick = (e) => {
    e.preventDefault();
    setShowPlatformFilter(!showPlatformFilter);
    setShowFormatFilter(false); // Close other filter
  };

  // Format filter handlers
  const handleFormatChange = (formatValue) => {
    setSelectedFormats(prev => {
      if (prev.includes(formatValue)) {
        return prev.filter(f => f !== formatValue);
      } else {
        return [...prev, formatValue];
      }
    });
    cardUpdate();
  };

  const handleSelectAllFormats = () => {
    setSelectedFormats(formatOptions.map(f => f.value));
    cardUpdate();
  };

  const handleUnselectAllFormats = () => {
    setSelectedFormats([]);
    cardUpdate();
  };

  const handleFormatFilterClick = (e) => {
    e.preventDefault();
    setShowFormatFilter(!showFormatFilter);
    setShowPlatformFilter(false); // Close other filter
  };

  // Close filters when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.platform-filter') && !event.target.closest('.format-filter')) {
        setShowPlatformFilter(false);
        setShowFormatFilter(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const bucketNav = [
    // {icon:faPencil, name: 'Edit Name', href: '#' },
    // { icon: faNoteSticky, name: "Create New Card", href: "#" },
    { icon: faTrash, name: "Select All", href: "#" },
    { icon: faTrash, name: "Unselect All", href: "#" },
    // {icon:faFolder, name: 'Customize New Card', href: '#' },
  ];




  function createSub() {
    // setPopup(false);
    setBucketOperation("subbucket");
    setBucketNameText("");
    setPopup(true);
    setTimeout(() => {
      document.getElementsByName("name")[0].focus();
    }, 100);
  }
  const handleOnChangeTitle = (e) => {
    setCardTitle(e.target.value);
  };

  const handleEditTitle = () => {
    setTitleState(false);
    setCardTitle(subBucket?.name);
    setTimeout(() => {
      document.getElementsByClassName("bucketeditname-content")[0].focus();
    }, 100);
  };
  const handleChildClick = (event) => {
    event.stopPropagation();
  };

  function cardUpdate() {
    // setBucketCreated(true);
    setLastList(false);
    setCurrPage(1);
    setPrevPage(0);
    setCardList([]);
    setCardCreated(!cardCreated);
  }

  function bucketUpdate() {
    // setBucketCreated(true);
    setBucketCreated(!bucketCreated);
  }



  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const normalizedSearchQuery = searchQuery.trim().toLowerCase();
  const hasActiveCardFilters = Boolean(normalizedSearchQuery || selectedPlatforms.length || selectedFormats.length);
  const visibleCards = normalizedSearchQuery
    ? cardList.filter((card) => {
      const searchableText = [
        card?.title,
        typeof card?.content === "string" ? card.content : card?.content?.text,
        card?.note,
        card?.postDetail?.title,
        card?.adData?.pageName,
        card?.adData?.headline,
        ...(card?.tags || []).map((tag) =>
          typeof tag === "string" ? tag : tag?.name
        ),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return searchableText.includes(normalizedSearchQuery);
    })
    : cardList;

  return (
    <>
      {isLoading ? (
        <div className="App-loading">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : (
        <div className="subBuckets-whole listingCards subBucketInner">
          <div
            className={`cards bucket-inner-layout ${
              subBucket?.subBuckets?.length
                ? ""
                : "bucket-inner-layout--no-sub-buckets"
            }`}
          >
            <div className="bucket-compact-header card-header flex min-h-[80px] flex-col justify-center border-b border-gray-200 bg-white px-4 py-4 dark:border-white/10 dark:bg-[#111111] sm:px-6">
              <div className="cardHeaderContent !pt-0">
                <div className="bucketNameTag !mb-0">
                  <nav className="flex min-w-0 items-center gap-3 text-sm" aria-label="Breadcrumb">
                    <a
                      href={`/app/buckets/${MainbucketId}`}
                      className="inline-flex flex-shrink-0 items-center gap-2 font-medium text-gray-600 transition-colors hover:text-gray-950 dark:text-slate-300 dark:hover:text-white"
                    >
                      <span aria-hidden="true" className="text-base font-light">&lsaquo;</span>
                      Back
                    </a>
                    <span className="text-slate-600" aria-hidden="true">/</span>
                    <a
                      href="/app/buckets"
                      className="flex-shrink-0 font-medium text-gray-600 transition-colors hover:text-gray-950 dark:text-slate-300 dark:hover:text-white"
                    >
                      My Buckets
                    </a>
                    <span className="text-slate-600" aria-hidden="true">/</span>
                    <a
                      href={`/app/buckets/${MainbucketId}`}
                      className="max-w-[30vw] truncate font-medium text-gray-600 transition-colors hover:text-gray-950 dark:text-slate-300 dark:hover:text-white"
                    >
                      {MainbucketName}
                    </a>
                    <span className="text-slate-600" aria-hidden="true">/</span>
                    <span className="truncate font-semibold text-gray-950 dark:text-white">
                      {subBucket.name}
                    </span>
                  </nav>
                </div>
                <div className="subbucketheaderdesktop-section !hidden">
                  <div className="subbucket-displaycontent">
                    <div className="flex items-center">
                      {titleState ? (
                        <h4 className="bucketName-content">
                          {subBucket?.name}
                        </h4>
                      ) : (
                        <>
                          <input
                            type="text"
                            className="bucketeditname-content"
                            value={cardTitle}
                            onChange={handleOnChangeTitle}
                            style={{
                              fontSize: "18px",
                              outline: "none",
                              border: "none",
                              padding: "0 10px",
                            }}
                          />
                        </>
                      )}
                      {!subBucket.default ? (
                        <div className="bucketActions flex items-center">
                          <span>
                            {titleState ? (
                              <img
                                className="subbuckets-dark"
                                src={EditIcon}
                                alt="editIcon"
                                onClick={handleEditTitle}
                              />
                            ) : (
                              <FontAwesomeIcon
                                style={{ height: "22px", cursor: "pointer" }}
                                icon={faCheck}
                                onClick={handleCardTitle}
                                color="gray"
                              />
                            )}
                          </span>
                          {/* <span>
                            <img
                              className="ml-[30px] mr-[30px]"
                              src={DeleteIcon}
                              alt="DeleteIcon"
                            />
                          </span> */}
                          <span className="ml-[30px]">

                          </span>
                          <div>
                            {/* <button className="buttonfilespadding-content text-[16px]" >
                                          <span className="filescardbutton-context flex"><span><img className="pl-2 pr-2" src={FilesOrange} alt="filesOrange" /><div id="overlay"></div></span>Files</span>
                                        </button> */}
                          </div>
                          {false && BucketSharePopup && (
                            <ShareBucket
                              shareBucketId={shareBucketId}
                              closeSharePop={closeSharePop}
                              bucketUpdate={bucketUpdate}
                              bucketPublicShare={bucketPublicShare}
                            />
                          )}


                          {false && filepopup && (
                            <div
                              className="filescreationpopup relative !z-[999]"
                              style={{ height: "100%" }}
                              onClick={closeFilePopup}
                            >
                              <div
                                className={
                                  filepopupAnimation
                                    ? "subfiles-section subbucketsfiles-wholesection"
                                    : "subfiles-section-menu-close subbucketsfiles-wholesection"
                                }
                                onClick={handleChildClick}
                              >
                                <div>
                                  <img
                                    className="dismissfiles-content"
                                    src={DismissButton}
                                    alt="dismissButton"
                                    onClick={closeFilePopup}
                                  />
                                </div>
                                <FilesPopup bucketName={subBucket.name} />
                              </div>
                            </div>
                          )}

                          {/* <div>
                                    <button className="buttonbookpadding-content text-[16px]" >
                                      <span className="filescardbutton-context flex"><span><img className="pl-2 pr-2" src={BookmarksOrange} alt="filesOrange" /></span>Bookmarks</span>
                                    </button>
                                  </div> */}
                          {false && bookmarkpopup && (
                            <div
                              className="filescreationpopup relative !z-[999]"
                              style={{ height: "100%" }}
                              onClick={closeBookmarkPopup}
                            >
                              <div
                                className={
                                  bookmarkpopupAnimation
                                    ? "subfiles-section subbucketsfiles-wholesection"
                                    : "subfiles-section-menu-closebookmark subbucketsfiles-wholesection"
                                }
                                onClick={handleChildClick}
                              >
                                <div>
                                  <img
                                    className="dismissfiles-content"
                                    src={DismissButton}
                                    alt="dismissButton"
                                    onClick={closeBookmarkPopup}
                                  />
                                </div>
                                <BookmarksPopup bucketName={subBucket.name} />
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {
                      !subBucket.default ?
                        <div
                          className="cardsjustify-end inviteBtn"
                          onClick={() => handleSharePop(bucketId.id)}
                        >
                          <button type="button" data-former-link=""
                            style={{
                              filter:
                                "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                            }}
                            className="btn-invited rounded-full bg-[#FF6600] text-white sm:text-sm  md:text-md lg:text-lg"

                          >
                            @ Invite People
                          </button>
                        </div> : ""
                    }

                  </div>
                </div>
                <div className="subbucketheadermbl-section !hidden">
                  <div className="subbucket-displaycontent">
                    <div className="flex items-center">
                      {titleState ? (
                        <h4 className="bucketName-content">
                          {subBucket?.name}
                        </h4>
                      ) : (
                        <>
                          <input
                            type="text"
                            className="bucketeditname-content"
                            value={cardTitle}
                            onChange={handleOnChangeTitle}
                            style={{
                              fontSize: "18px",
                              outline: "none",
                              border: "none",
                              padding: "0 10px",
                            }}
                          />
                        </>
                      )}
                      {!subBucket.default ? (
                        <div className="bucketActions flex items-center">
                          <span>
                            {titleState ? (
                              <img
                                className="subbuckets-dark"
                                src={EditIcon}
                                alt="editIcon"
                                onClick={handleEditTitle}
                              />
                            ) : (
                              <FontAwesomeIcon
                                style={{ height: "22px", cursor: "pointer" }}
                                icon={faCheck}
                                onClick={handleCardTitle}
                                color="gray"
                              />
                            )}
                          </span>
                          {/* <span>
                            <img
                              className="ml-[30px] mr-[30px]"
                              src={DeleteIcon}
                              alt="DeleteIcon"
                            />
                          </span> */}
                          <span className="ml-[30px]">

                          </span>
                          <div>
                            {/* <button className="buttonfilespadding-content text-[16px]" >
                                          <span className="filescardbutton-context flex"><span><img className="pl-2 pr-2" src={FilesOrange} alt="filesOrange" /><div id="overlay"></div></span>Files</span>
                                        </button> */}
                          </div>
                          {false && BucketSharePopup && (
                            <ShareBucket
                              shareBucketId={shareBucketId}
                              closeSharePop={closeSharePop}
                              bucketUpdate={bucketUpdate}
                              bucketPublicShare={bucketPublicShare}
                            />
                          )}


                          {false && filepopup && (
                            <div
                              className="filescreationpopup relative !z-[999]"
                              style={{ height: "100%" }}
                              onClick={closeFilePopup}
                            >
                              <div
                                className={
                                  filepopupAnimation
                                    ? "subfiles-section subbucketsfiles-wholesection"
                                    : "subfiles-section-menu-close subbucketsfiles-wholesection"
                                }
                                onClick={handleChildClick}
                              >
                                <div>
                                  <img
                                    className="dismissfiles-content"
                                    src={DismissButton}
                                    alt="dismissButton"
                                    onClick={closeFilePopup}
                                  />
                                </div>
                                <FilesPopup bucketName={subBucket.name} />
                              </div>
                            </div>
                          )}

                          {/* <div>
                                    <button className="buttonbookpadding-content text-[16px]" >
                                      <span className="filescardbutton-context flex"><span><img className="pl-2 pr-2" src={BookmarksOrange} alt="filesOrange" /></span>Bookmarks</span>
                                    </button>
                                  </div> */}
                          {false && bookmarkpopup && (
                            <div
                              className="filescreationpopup relative !z-[999]"
                              style={{ height: "100%" }}
                              onClick={closeBookmarkPopup}
                            >
                              <div
                                className={
                                  bookmarkpopupAnimation
                                    ? "subfiles-section subbucketsfiles-wholesection"
                                    : "subfiles-section-menu-closebookmark subbucketsfiles-wholesection"
                                }
                                onClick={handleChildClick}
                              >
                                <div>
                                  <img
                                    className="dismissfiles-content"
                                    src={DismissButton}
                                    alt="dismissButton"
                                    onClick={closeBookmarkPopup}
                                  />
                                </div>
                                <BookmarksPopup bucketName={subBucket.name} />
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* {
                      !subBucket.default?
                      <div
                      className="cardsjustify-end inviteBtn"
                      onClick={() => handleSharePop(bucketId.id)}
                    >
                      <a
                        style={{
                          filter:
                            "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                        }}
                        className="btn-invited rounded-full bg-[#FF6600] text-white sm:text-sm  md:text-md lg:text-lg"
                        href="#"
                      >
                        @ Invite People
                      </a>
                    </div> : ""
                    } */}

                  </div>
                </div>
              </div>
            </div>
            <div className="mt-[3px] mb-[3px] hidden text-[14px] lg:text-[17px]">
              <a className="flex items-center" href="/">
                <img
                  src={CalenderIcon}
                  alt="calenderIcon"
                  className="w-[22px] dark-mode-icon"
                />{" "}
                <span className="createdtext-content pl-2 dark:text-[#bbbbbb]">
                  Created{" "}
                  {moment(subBucket.createdAt).format("MMM D, YYYY @ hh:mm A")}
                </span>
              </a>{" "}
            </div>
            <div className="subbucketheadermbl-section gfhgfhgf !hidden">
              {
                !subBucket.default ?
                  <div className="cardsjustify-end inviteBtn">
                    <button type="button" data-former-link=""
                      style={{
                        filter: "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                      }}
                      className="btn-invited rounded-full bg-[#FF6600] text-white sm:text-sm  md:text-md lg:text-lg"

                      onClick={() => handleSharePop(bucketId.id)}
                    >
                      @ Invite People
                    </button>
                  </div> : ""
              }
            </div>

            <hr className="!hidden" />
            {/* <div className="cardHeaderDetails mt-3">
                  <ul className="flex ">
                    <button style={{filter: 'drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))'}} className="buttoncardpadding-content text-[16px] bg-[#FF6600] text-white">
                      <span className="savecardbutton-context">Sub Buckets</span>
                    </button>
                    <button style={{filter: 'drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))'}} className="buttoncardpadding-content text-[16px] bg-[#FF6600] text-white">
                      <span className="savecardbutton-context">Files</span>
                    </button>
                    <button style={{filter: 'drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))'}} className="buttoncardpadding-content text-[16px] bg-[#FF6600] text-white">
                      <span className="savecardbutton-context">Cards</span>
                    </button>
                    <button style={{filter: 'drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))'}} className="buttoncardpadding-content text-[16px] bg-[#FF6600] text-white">
                      <span className="savecardbutton-context">Bookmarks</span>
                    </button>
                  </ul>
                </div> */}
            {BucketSharePopup && (
              <ShareBucket
                shareBucketId={shareBucketId}
                closeSharePop={closeSharePop}
                bucketUpdate={bucketUpdate}
                bucketPublicShare={bucketPublicShare}
              />
            )}
            {filepopup && (
              <div
                className={`filescreationpopup bucket-drawer-overlay relative !z-[999] ${filepopupAnimation ? "bucket-drawer-overlay--open" : ""}`}
                style={{ height: "100%" }}
                onClick={closeFilePopup}
              >
                <div
                  className={
                    filepopupAnimation
                      ? "subfiles-section subbucketsfiles-wholesection"
                      : "subfiles-section-menu-close subbucketsfiles-wholesection"
                  }
                  role="dialog"
                  aria-modal="true"
                  aria-label="Files"
                  onClick={handleChildClick}
                >
                  <button type="button" className="bucket-drawer-close" onClick={closeFilePopup} aria-label="Close files drawer" autoFocus>
                    <img src={DismissButton} alt="" />
                  </button>
                  <FilesPopup bucketName={subBucket.name} />
                </div>
              </div>
            )}
            {bookmarkpopup && (
              <div
                className={`filescreationpopup bucket-drawer-overlay relative !z-[999] ${bookmarkpopupAnimation ? "bucket-drawer-overlay--open" : ""}`}
                style={{ height: "100%" }}
                onClick={closeBookmarkPopup}
              >
                <div
                  className={
                    bookmarkpopupAnimation
                      ? "subfiles-section subbucketsfiles-wholesection"
                      : "subfiles-section-menu-closebookmark subbucketsfiles-wholesection"
                  }
                  role="dialog"
                  aria-modal="true"
                  aria-label="Bookmarks"
                  onClick={handleChildClick}
                >
                  <button type="button" className="bucket-drawer-close" onClick={closeBookmarkPopup} aria-label="Close bookmarks drawer" autoFocus>
                    <img src={DismissButton} alt="" />
                  </button>
                  <BookmarksPopup bucketName={subBucket.name} />
                </div>
              </div>
            )}

            {Custompopup && (
              <div
                className="filesbucketuploadpopup relative !z-[999]"
                style={{ height: "100%" }}
                onClick={closeCustomPopup}
              >
                <div
                  className="subfilesbucketupload-section"
                  onClick={handleChildClick}
                >
                  <div onClick={closeCustomPopup}>
                    <img
                      className="dismissSubfiles-content"
                      src={PopUpClose}
                      alt="dismissButton"
                    />
                  </div>
                  <CustomizePopup
                    selectedBucketName={selectedBucketName}
                    selectedBucketId={selectedBucketId}
                    closeCustomPopup={closeCustomPopup}
                    bucketUpdate={bucketUpdate}
                  />
                </div>
              </div>
            )}
            {!subBucket.default ? (
              <div className="subBucketsHolder">
                <div className="subbucket-displaycontent">
                  <div className="subBuckets flex items-center">
                    {/* <h4 className="subbucketstext-content">Sub Buckets</h4>
                    <span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">
                      {subBucket?.subBuckets?.length}
                    </span> */}
                  </div>
                  <div className="flex 4 cardsjustify-end"></div>
                </div>
                <div className="cardsjustify-end justify-end">
                  <button type="button" onClick={handleFilePopup} className="fileSub-imgcontent" aria-label={`Files (${filePopupCount})`}>
                    <span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px] file-count-popup">{filePopupCount}</span>
                    <img className="filesub-bgcontent" src={FilesSub} alt="" />
                  </button>
                </div>
                <div className="cardsjustify-end justify-end">
                  <button type="button" onClick={handleBookmarkPopup} className="bookmarksSub-imgcontent" aria-label={`Bookmarks (${bookmarkPopupCount})`}>
                    <span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px] bookmarks-count-popup">{bookmarkPopupCount}</span>
                    <img className="filesub-bgcontent" src={NewBookmarksSub} alt="" />
                  </button>
                </div>
              </div>
            ) : (
              ""
            )}

            {/* <div className="cards-filter  pt-[80px] flex justify-between">
                    <div className="flex items-center">
                        <div className="card-count flex items-center">
                            <h4 className="cardssubBuckets-content">Files</h4><span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">{cardList?.length}</span>
                        </div>
                        <Menu as="div" className="relative px-2">
                            <Menu.Button
                                className="relative ml-3 inline-flex items-center px-1 py-2 text-sm font-semibold text-gray-900 "
                            >
                                <img className="threedots-content" src={ThreeDots} alt="threeDots" />
                            </Menu.Button>
                            <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                >
                                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                    {bucketNav.map((item) => (
                                        <Menu.Item key={item.name}>
                                        {({ active }) => (
                                            <a
                                            href={item.href}
                                            className={classNames(
                                                active ? 'bg-gray-100' : '',
                                                'block py-2 px-4 text-sm text-gray-700'
                                            )}
                                            >
                                                <span className="pr-2"><FontAwesomeIcon className="text-[#797979]" icon={item.icon} /></span>
                                            <span className="text-black">{item.name}</span>
                                            </a>
                                        )}
                                        </Menu.Item>
                                    ))}
                                    </Menu.Items>
                                </Transition>
                        </Menu>
                        <img src={DeleteIcon} alt="deleteIcon" className="px-3" onClick={()=>deleteCard()}/>
                        <Transition appear show={isOpenss} as={Fragment}>
                          <Dialog as="div" className="relative z-10" onClose={closeCardModal}>
                            <Transition.Child
                              as={Fragment}
                              enter="ease-out duration-300"
                              enterFrom="opacity-0"
                              enterTo="opacity-100"
                              leave="ease-in duration-200"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                            >
                              <div className="fixed inset-0 bg-black bg-opacity-25" />
                            </Transition.Child>

                            <div className="fixed inset-0 overflow-y-auto">
                              <div className="flex min-h-full items-center justify-center p-4 text-center">
                                <Transition.Child
                                  as={Fragment}
                                  enter="ease-out duration-300"
                                  enterFrom="opacity-0 scale-95"
                                  enterTo="opacity-100 scale-100" 
                                  leave="ease-in duration-200"
                                  leaveFrom="opacity-100 scale-100"
                                  leaveTo="opacity-0 scale-95"
                                >
                                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                                    <Dialog.Title
                                      as="h3"
                                      className="text-lg font-medium leading-6 text-gray-900"
                                    >
                                      Delete
                                    </Dialog.Title>
                                    <div className="mt-2">
                                      <p className="text-sm text-gray-500">
                                        Are you sure you want to delete?
                                      </p>
                                    </div>

                                    <div className="mt-4">
                                      <button style={{background:'#FF6600',width:"80px",color:"#fff",padding:"10px",borderRadius:"50px"}}
                                        type="button"
                                        className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                        onClick={() => handleDeleteCard()}
                                      >
                                        Yes
                                      </button>
                                      <button style={{background:'#000',width:"80px",color:"#fff",padding:"10px",borderRadius:"50px"}}
                                        type="button"
                                        className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                        onClick={closeCardModal}
                                      >
                                        No
                                      </button>
                                    </div>
                                  </Dialog.Panel>
                                </Transition.Child>
                              </div>
                            </div>
                          </Dialog>
                        </Transition>
                    </div>
                    <div className="flex">
                    <div className="filterHolder flex items-center justify-end">
                        <div className="filter display-content"> 
                        {isListView &&
                          <div onClick={handleIsListView}>
                            <a className="viewGrid" href="#">                            
                             <img className="mt-1 listcard-imgcontent" src={ListView} style={{color:'#000000'}}  alt="listView" />
                            </a>
                          </div>
                        }
                        {isGridView &&
                          <div onClick={handleIsGridView}>
                            <a className="viewGrid" href="#">                            
                             <img className="mt-1 compact-imgcontent" src={compactCardIcon} alt="compactIcon" />
                            </a>
                          </div>
                        }
                        </div>

                        <span className="sorttext-content mx-3 dark:text-[#acacac]">Sort By</span>
                        <Menu as="div" className="relative flex-shrink-0">
                          <div>
                            <Menu.Button className="flex rounded-full focus:outline-none ">
                                  <a
                                    href="#"
                                    className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                                  >
                                  <strong className="createdtext-content pr-4">Upload Date</strong>
                                  <FontAwesomeIcon style={{fontSize:'12px',color:'#707070'}} icon={faChevronDown} />
                              </a>
                            </Menu.Button>
                          </div>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">

                              {filterFilesDropDown.map((item) => (
                                <Menu.Item key={item.name}>
                                  {({ active }) => (

                                    <a
                                      onClick={()=>{handleFilterFilesText(item.name)}}
                                      href={item.href}
                                      className={classNames(
                                        active ? 'bg-gray-100' : '',
                                        'block py-2 px-4 text-sm text-gray-700'
                                      )}
                                    >
                                      {item.name}
                                    </a>
                                  )}
                                </Menu.Item>
                              ))}
                            </Menu.Items>
                          </Transition>
                        </Menu>
                    </div>
                    </div>
                </div>  */}

            {/* {isListViewOpen &&
                  <div>
                    <div className="flex fileswhole-section">
                      <div className="file-section fileheading-content filespace-content">File name</div>
                      <div className="bucket-section fileheading-content">Bucket name</div>
                      <div className="upload-section fileheading-content">Upload date</div>
                      <div className="sharedwith-section fileheading-content">Shared with</div>
                      <div className="size-section fileheading-content">Size</div>
                      <div className="action-section fileheading-content">Action</div>
                    </div>
                    <hr/>
                    <div className="flex spacefiles-content">
                      <div className="file-section flex"><input id="default-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" /><img className="pl-3 pr-3" src={Document} alt="document" /><span className="filesection-content">UX/UI Design Trends & Fashion</span></div>
                      <div className="bucket-section filesection-content">Fashion Trends 2022 Sketch</div>
                      <div className="upload-section filesection-content">Dec 4, 2021 @ 4:30 PM</div>
                      <div className="sharedwith-section">
                        <div className="profile-imgcontent">
                          <img src={Profile1} alt="profile1" />
                          <img src={Profile2} alt="profile2" />
                        </div>
                      </div>
                      <div className="size-section filesection-content">14 MB</div>
                      <div className="action-section flex">
                        <img className="tooltip-icon mr-3" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-3" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-3" src={SubTag} alt="subTag"/>
                        <img className="mr-3" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon mr-3" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                        <img src={ThreeDots} alt="threeDots" />
                      </div>
                    </div>
                    <div className="flex spacefiles-content">
                      <div className="file-section flex"><input id="default-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" /><img className="pl-3 pr-3" src={PDF} alt="PDF" /><span className="filesection-content">Fashion year - '23</span></div>
                      <div className="bucket-section filesection-content">Ganesh's fashion Bucket</div>
                      <div className="upload-section filesection-content">Dec 4, 2021 @ 4:30 PM</div>
                      <div className="sharedwith-section">-</div>
                      <div className="size-section filesection-content">85 MB</div>
                      <div className="action-section flex">
                        <img className="tooltip-icon mr-3" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-3" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-3" src={SubTag} alt="subTag"/>
                        <img className="mr-3" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon mr-3" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                        <img src={ThreeDots} alt="threeDots" />
                      </div>
                    </div>
                    <div className="flex spacefiles-content">
                      <div className="file-section flex"><input id="default-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" /><img className="pl-3 pr-3" src={ImageFolder} alt="ImageFolder" /><span className="filesection-content">UX/UI Design Trends & Fashion</span></div>
                      <div className="bucket-section filesection-content">Fashion Trends 2022 Sketch</div>
                      <div className="upload-section filesection-content">Dec 4, 2021 @ 4:30 PM</div>
                      <div className="sharedwith-section">-</div>
                      <div className="size-section filesection-content">250 MB</div>
                      <div className="action-section flex">
                        <img className="tooltip-icon mr-3" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-3" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-3" src={SubTag} alt="subTag"/>
                        <img className="mr-3" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon mr-3" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                        <img src={ThreeDots} alt="threeDots" />
                      </div>
                    </div>
                    <div className="flex spacefiles-content">
                      <div className="file-section flex"><input id="default-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" /><img className="pl-3 pr-3" src={Document} alt="document" /><span className="filesection-content">UX/UI Design Trends & Fashion</span></div>
                      <div className="bucket-section filesection-content">Fashion Trends 2022 Sketch</div>
                      <div className="upload-section filesection-content">Dec 4, 2021 @ 4:30 PM</div>
                      <div className="sharedwith-section">
                        <div className="profile-imgcontent">
                          <img src={Profile1} alt="profile1" />
                          <img src={Profile2} alt="profile2" />
                        </div>
                      </div>
                      <div className="size-section filesection-content">14 MB</div>
                      <div className="action-section flex">
                        <img className="tooltip-icon mr-3" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-3" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-3" src={SubTag} alt="subTag"/>
                        <img className="mr-3" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon mr-3" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                        <img src={ThreeDots} alt="threeDots" />
                      </div>
                    </div>
                    <div className="flex spacefiles-content">
                      <div className="file-section flex"><input id="default-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" /><img className="pl-3 pr-3" src={PDF} alt="PDF" /><span className="filesection-content">Fashion year - '23</span></div>
                      <div className="bucket-section filesection-content">Ganesh's fashion Bucket</div>
                      <div className="upload-section filesection-content">Dec 4, 2021 @ 4:30 PM</div>
                      <div className="sharedwith-section">-</div>
                      <div className="size-section filesection-content">85 MB</div>
                      <div className="action-section flex">
                        <img className="tooltip-icon mr-3" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-3" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-3" src={SubTag} alt="subTag"/>
                        <img className="mr-3" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon mr-3" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                        <img src={ThreeDots} alt="threeDots" />
                      </div>
                    </div>
                  </div>
                } 

                {isGridViewOpen &&
                  <div className="filescard-section md:masonry-2-col lg:masonry-4-col">
                    <div className="cardHolder-cards rounded-[14px] overflow-hidden mb-3 break-inside">
                      <div className="flex justify-between w-full pt-3 pb-1">
                        <div className="inputCheck">
                          <input type="checkbox" />
                        </div>                        
                      </div>
                      <div className="cardHeader flex items-center pb-2">
                        <div className="Cardtitle flex">
                          <img className="mr-2" src={Document} alt="document" />
                          <h3 className="design-textcontent">UX/UI Design Trends & Fashion year - '23</h3>
                        </div>
                        <div className="iconsRight flex iconsalign-content">
                          <FontAwesomeIcon className="text-[#707070] text-[22px] ml-4 mr-1" icon={faEllipsisVertical} />
                        </div>
                      </div>
                      <div className="cardContent w-full">
                        <img className="w-full" src={CardImage1} alt="projectImg1" />
                      </div>
                      <div className="flex">
                        <div>                          
                          <div className="fashioncards-content createalign-content">Fashion Trends 2022 Sketch</div>
                          <div className="uploadedcards-content pb-2">Uploaded on Dec 4, 2021 @ 4:30 PM</div>
                        </div>
                        <div className="profile-displaycontent">
                          <div className="profile-imgcontent">
                            <img src={Profile1} alt="profile1" />
                            <img src={Profile2} alt="profile2" />
                            <img src={Profile3} alt="profile3" /><br/>
                          </div>
                          <p className="sharesright-content">0+ Shares</p>
                        </div>
                      </div>
                      <div className="flex cardsicon-content">
                        <img className="tooltip-icon mr-11" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-11" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-11" src={SubTag} alt="subTag"/>
                        <img className="mr-11" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                      </div>
                    </div>
                    <div className="cardHolder-cards rounded-[14px] overflow-hidden mb-3 break-inside">
                      <div className="flex justify-between w-full pt-3 pb-1">
                        <div className="inputCheck">
                          <input type="checkbox" />
                        </div>                        
                      </div>
                      <div className="cardHeader flex items-center pb-5">
                        <div className="Cardtitle flex">
                          <img className="mr-2" src={PDF} alt="pdf" />
                          <h3 className="design-textcontent">Fashion year - '23</h3>
                        </div>
                        <div className="iconsRight flex iconsalign-content">
                          <FontAwesomeIcon className="text-[#707070] text-[22px] ml-4 mr-1" icon={faEllipsisVertical} />
                        </div>
                      </div>
                      <div className="cardContent w-full">
                        <img className="w-full" src={CardImage2} alt="projectImg1" />
                      </div>
                      <div className="flex">
                        <div>                          
                          <div className="fashioncards-content createalign-content">Fashion Trends 2022 Sketch</div>
                          <div className="uploadedcards-content pb-2">Uploaded on Dec 4, 2021 @ 4:30 PM</div>
                        </div>
                        <div className="profile-displaycontent">
                          <div className="profile-imgcontent">
                            <img src={Profile1} alt="profile1" />
                            <img src={Profile2} alt="profile2" />
                            <img src={Profile3} alt="profile3" /><br/>
                          </div>
                          <p className="sharesright-content">0+ Shares</p>
                        </div>
                      </div>
                      <div className="flex cardsicon-content">
                        <img className="tooltip-icon mr-11" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-11" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-11" src={SubTag} alt="subTag"/>
                        <img className="mr-11" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                      </div>
                    </div>
                    <div className="cardHolder-cards rounded-[14px] overflow-hidden mb-3 break-inside">
                      <div className="flex justify-between w-full pt-3 pb-1">
                        <div className="inputCheck">
                          <input type="checkbox" />
                        </div>                        
                      </div>
                      <div className="cardHeader flex items-center pb-2">
                        <div className="Cardtitle flex">
                          <img className="mr-2" src={ImageFolder} alt="imageFolder" />
                          <h3 className="design-textcontent">UX/UI Design Trends & Fashion year - '23</h3>
                        </div>
                        <div className="iconsRight flex iconsalign-content">
                          <FontAwesomeIcon className="text-[#707070] text-[22px] ml-4 mr-1" icon={faEllipsisVertical} />
                        </div>
                      </div>
                      <div className="cardContent w-full">
                        <img className="w-full" src={CardImage2} alt="projectImg1" />
                      </div>
                      <div className="flex">
                        <div>                          
                          <div className="fashioncards-content createalign-content">Fashion Trends 2022 Sketch</div>
                          <div className="uploadedcards-content pb-2">Uploaded on Dec 4, 2021 @ 4:30 PM</div>
                        </div>
                        <div className="profile-displaycontent">
                          <div className="profile-imgcontent">
                            <img src={Profile1} alt="profile1" />
                            <img src={Profile2} alt="profile2" />
                            <img src={Profile3} alt="profile3" /><br/>
                          </div>
                          <p className="sharesright-content">0+ Shares</p>
                        </div>
                      </div>
                      <div className="flex cardsicon-content">
                        <img className="tooltip-icon mr-11" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-11" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-11" src={SubTag} alt="subTag"/>
                        <img className="mr-11" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                      </div>
                    </div>
                    <div className="cardHolder-cards rounded-[14px] overflow-hidden mb-3 break-inside">
                      <div className="flex justify-between w-full pt-3 pb-1">
                        <div className="inputCheck">
                          <input type="checkbox" />
                        </div>                        
                      </div>
                      <div className="cardHeader flex items-center pb-2">
                        <div className="Cardtitle flex">
                          <img className="mr-2" src={Document} alt="document" />
                          <h3 className="design-textcontent">UX/UI Design Trends & Fashion year - '23</h3>
                        </div>
                        <div className="iconsRight flex iconsalign-content">
                          <FontAwesomeIcon className="text-[#707070] text-[22px] ml-4 mr-1" icon={faEllipsisVertical} />
                        </div>
                      </div>
                      <div className="cardContent w-full">
                        <img className="w-full" src={CardImage1} alt="projectImg1" />
                      </div>
                      <div className="flex">
                        <div>                          
                          <div className="fashioncards-content createalign-content">Fashion Trends 2022 Sketch</div>
                          <div className="uploadedcards-content pb-2">Uploaded on Dec 4, 2021 @ 4:30 PM</div>
                        </div>
                        <div className="profile-displaycontent">
                          <div className="profile-imgcontent">
                            <img src={Profile1} alt="profile1" />
                            <img src={Profile2} alt="profile2" />
                            <img src={Profile3} alt="profile3" /><br/>
                          </div>
                          <p className="sharesright-content">0+ Shares</p>
                        </div>
                      </div>
                      <div className="flex cardsicon-content">
                        <img className="tooltip-icon mr-11" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-11" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-11" src={SubTag} alt="subTag"/>
                        <img className="mr-11" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                      </div>
                    </div>
                    <div className="cardHolder-cards rounded-[14px] overflow-hidden mb-3 break-inside">
                      <div className="flex justify-between w-full pt-3 pb-1">
                        <div className="inputCheck">
                          <input type="checkbox" />
                        </div>                        
                      </div>
                      <div className="cardHeader flex items-center pb-5">
                        <div className="Cardtitle flex">
                          <img className="mr-2" src={PDF} alt="pdf" />
                          <h3 className="design-textcontent">Fashion year - '23</h3>
                        </div>
                        <div className="iconsRight flex iconsalign-content">
                          <FontAwesomeIcon className="text-[#707070] text-[22px] ml-4 mr-1" icon={faEllipsisVertical} />
                        </div>
                      </div>
                      <div className="cardContent w-full">
                        <img className="w-full" src={CardImage2} alt="projectImg1" />
                      </div>
                      <div className="flex">
                        <div>                          
                          <div className="fashioncards-content createalign-content">Fashion Trends 2022 Sketch</div>
                          <div className="uploadedcards-content pb-2">Uploaded on Dec 4, 2021 @ 4:30 PM</div>
                        </div>
                        <div className="profile-displaycontent">
                          <div className="profile-imgcontent">
                            <img src={Profile1} alt="profile1" />
                            <img src={Profile2} alt="profile2" />
                            <img src={Profile3} alt="profile3" /><br/>
                          </div>
                          <p className="sharesright-content">0+ Shares</p>
                        </div>
                      </div>
                      <div className="flex cardsicon-content">
                        <img className="tooltip-icon mr-11" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-11" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-11" src={SubTag} alt="subTag"/>
                        <img className="mr-11" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                      </div>
                    </div>
                    <div className="cardHolder-cards rounded-[14px] overflow-hidden mb-3 break-inside">
                      <div className="flex justify-between w-full pt-3 pb-1">
                        <div className="inputCheck">
                          <input type="checkbox" />
                        </div>                        
                      </div>
                      <div className="cardHeader flex items-center pb-5">
                        <div className="Cardtitle flex">
                          <img className="mr-2" src={PDF} alt="pdf" />
                          <h3 className="design-textcontent">Fashion year - '23</h3>
                        </div>
                        <div className="iconsRight flex iconsalign-content">
                          <FontAwesomeIcon className="text-[#707070] text-[22px] ml-4 mr-1" icon={faEllipsisVertical} />
                        </div>
                      </div>
                      <div className="cardContent w-full">
                        <img className="w-full" src={CardImage2} alt="projectImg1" />
                      </div>
                      <div className="flex">
                        <div>                          
                          <div className="fashioncards-content createalign-content">Fashion Trends 2022 Sketch</div>
                          <div className="uploadedcards-content pb-2">Uploaded on Dec 4, 2021 @ 4:30 PM</div>
                        </div>
                        <div className="profile-displaycontent">
                          <div className="profile-imgcontent">
                            <img src={Profile1} alt="profile1" />
                            <img src={Profile2} alt="profile2" />
                            <img src={Profile3} alt="profile3" /><br/>
                          </div>
                          <p className="sharesright-content">0+ Shares</p>
                        </div>
                      </div>
                      <div className="flex cardsicon-content">
                        <img className="tooltip-icon mr-11" src={ClipBoard} alt="clipboardNotes" style={{width:"20px"}}/>
                        <img className="mr-11" src={SubStar} alt="subStar" style={{width:"20px"}} />
                        <img className="subtags mr-11" src={SubTag} alt="subTag"/>
                        <img className="mr-11" src={SubShare} alt="subShare" />
                        <img className="linkcards-icon" src={linkIcon} alt="link-icon" style={{width:"20px"}} />
                      </div>
                    </div>
                  </div>
                } */}

            <div className="bucket-cards-toolbar relative flex flex-col items-stretch justify-between gap-4 border-b border-gray-200 bg-white px-4 py-7 dark:border-white/10 dark:bg-[#090909] sm:px-6 xl:flex-row xl:items-center xl:gap-6">
              <div className="flex min-w-0 flex-1 items-center gap-4 xl:gap-6">
                <div className="flex min-w-0 flex-shrink-0 items-center gap-3">
                  {titleState ? (
                    <h4 className="max-w-[240px] truncate text-3xl font-bold leading-none tracking-tight text-gray-950 dark:text-white">
                      {subBucket?.name || "Cards"}
                    </h4>
                  ) : (
                    <div className="flex items-center gap-2">
                      <input
                        type="text"
                        value={cardTitle}
                        onChange={handleOnChangeTitle}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") handleCardTitle();
                          if (event.key === "Escape") setTitleState(true);
                        }}
                        className="bucket-toolbar-name-input h-11 w-[240px] rounded-xl border border-gray-300 bg-white px-3 text-3xl font-bold tracking-tight text-gray-950 outline-none focus:border-orange-500 dark:border-white/15 dark:bg-white/5 dark:text-white"
                        aria-label="Sub-bucket name"
                      />
                      <button
                        type="button"
                        onClick={handleCardTitle}
                        className="flex h-10 w-10 items-center justify-center rounded-xl bg-gray-100 text-gray-900 hover:bg-gray-200 dark:bg-white/10 dark:text-white dark:hover:bg-white/15"
                        aria-label="Save sub-bucket name"
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                    </div>
                  )}
                  <span className="inline-flex min-w-[46px] items-center justify-center rounded-full bg-gray-100 px-3 py-2 text-sm font-semibold text-gray-700 dark:bg-white/[0.06] dark:text-gray-200">
                    {totalCards}
                  </span>
                  <Menu as="div" className="relative">
                    <Menu.Button
                      className="flex h-10 w-10 items-center justify-center rounded-xl text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-900 focus:outline-none dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-white"
                      aria-label="Card actions"
                    >
                      <FontAwesomeIcon icon={faEllipsisVertical} />
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-50 mt-2 w-56 origin-top-right overflow-hidden rounded-xl border border-gray-200 bg-white py-1 shadow-2xl focus:outline-none dark:border-white/10 dark:bg-[#171717]">
                        {!subBucket.default && (
                          <>
                            <Menu.Item>
                              {({ active }) => (
                                <button
                                  type="button"
                                  onClick={handleEditTitle}
                                  className={`flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm ${active ? "bg-gray-100 text-gray-950 dark:bg-white/10 dark:text-white" : "text-gray-700 dark:text-gray-300"}`}
                                >
                                  <img src={EditIcon} alt="" className="h-4 w-4 opacity-70" />
                                  Edit name
                                </button>
                              )}
                            </Menu.Item>
                            <Menu.Item>
                              {({ active }) => (
                                <button
                                  type="button"
                                  onClick={createSub}
                                  className={`flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm ${active ? "bg-gray-100 text-gray-950 dark:bg-white/10 dark:text-white" : "text-gray-700 dark:text-gray-300"}`}
                                >
                                  <span className="w-4 text-center text-lg leading-none">+</span>
                                  Create sub bucket
                                </button>
                              )}
                            </Menu.Item>
                            <Menu.Item>
                              {({ active }) => (
                                <button
                                  type="button"
                                  onClick={() => handleSharePop(bucketId.id)}
                                  className={`flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm ${active ? "bg-gray-100 text-gray-950 dark:bg-white/10 dark:text-white" : "text-gray-700 dark:text-gray-300"}`}
                                >
                                  <span className="w-4 text-center font-semibold">@</span>
                                  Invite people
                                </button>
                              )}
                            </Menu.Item>
                            <div className="my-1 border-t border-gray-200 dark:border-white/10" />
                          </>
                        )}
                        {cardList.length > 0 && bucketNav.map((item) => (
                          <Menu.Item key={item.name}>
                            {({ active }) => (
                              <button
                                type="button"
                                onClick={() => handleCardClick(item.name)}
                                className={`flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm ${active ? "bg-gray-100 text-gray-950 dark:bg-white/10 dark:text-white" : "text-gray-700 dark:text-gray-300"}`}
                              >
                                <FontAwesomeIcon className="text-gray-500" icon={item.icon} />
                                {item.name}
                              </button>
                            )}
                          </Menu.Item>
                        ))}
                        {selectedItems.length > 0 && <Menu.Item>
                          {({ active }) => (
                            <button
                              type="button"
                              onClick={MoveCard}
                              className={`flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm ${active ? "bg-gray-100 text-gray-950 dark:bg-white/10 dark:text-white" : "text-gray-700 dark:text-gray-300"}`}
                            >
                              <img src={Arrow} alt="" className="h-4 w-4 dark:invert" />
                              Move selected
                            </button>
                          )}
                        </Menu.Item>}
                        <div className="mt-1 border-t border-gray-200 px-4 py-2 text-xs text-gray-400 dark:border-white/10 dark:text-gray-500">
                          Created {moment(subBucket.createdAt).format("MMM D, YYYY @ hh:mm A")}
                        </div>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>

                <label className="relative block min-w-[220px] max-w-[375px] flex-1">
                  <span className="sr-only">Search cards</span>
                  <Search className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-500" />
                  <input
                    type="search"
                    value={searchQuery}
                    onChange={(event) => setSearchQuery(event.target.value)}
                    placeholder="Search cards..."
                    className="h-[52px] w-full rounded-2xl border border-gray-200 bg-gray-50 py-2 pl-12 pr-11 text-sm text-gray-950 outline-none transition-colors placeholder:text-gray-400 focus:border-gray-300 focus:bg-white dark:border-white/10 dark:bg-white/[0.045] dark:text-white dark:placeholder:text-slate-500 dark:focus:border-white/20 dark:focus:bg-white/[0.07]"
                  />
                  {searchQuery && (
                    <button
                      type="button"
                      onClick={() => setSearchQuery("")}
                      className="absolute right-3 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-800 dark:text-gray-500 dark:hover:bg-white/10 dark:hover:text-white"
                      aria-label="Clear search"
                    >
                      <X className="h-4 w-4" />
                    </button>
                  )}
                </label>
              </div>

              <div className="flex flex-shrink-0 flex-wrap items-center gap-2 xl:flex-nowrap">
                <div className="platform-filter relative">
                  <button
                    type="button"
                    onClick={handlePlatformFilterClick}
                    className="flex h-[52px] items-center gap-3 rounded-2xl border border-gray-200 bg-white px-4 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none dark:border-white/10 dark:bg-white/[0.045] dark:text-gray-200 dark:hover:bg-white/[0.08]"
                    aria-expanded={showPlatformFilter}
                  >
                    Platform ({selectedPlatforms.length})
                    <FontAwesomeIcon className="text-xs text-gray-500" icon={faChevronDown} />
                  </button>
                  {showPlatformFilter && (
                    <div className="absolute right-0 z-50 mt-2 w-52 origin-top-right overflow-hidden rounded-xl border border-gray-200 bg-white py-1 shadow-2xl dark:border-white/10 dark:bg-[#171717]">
                      {platformOptions.map((platform) => (
                        <button
                          key={platform.value}
                          type="button"
                          onClick={() => handlePlatformChange(platform.value)}
                          className="flex w-full items-center justify-between px-4 py-2.5 text-sm text-gray-700 transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10"
                        >
                          <span>{platform.name}</span>
                          {selectedPlatforms.includes(platform.value) && (
                            <FontAwesomeIcon icon={faCheck} className="text-sm text-orange-500" />
                          )}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <div className="format-filter relative">
                  <button
                    type="button"
                    onClick={handleFormatFilterClick}
                    className="flex h-[52px] items-center gap-3 rounded-2xl border border-gray-200 bg-white px-4 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none dark:border-white/10 dark:bg-white/[0.045] dark:text-gray-200 dark:hover:bg-white/[0.08]"
                    aria-expanded={showFormatFilter}
                  >
                    Format ({selectedFormats.length})
                    <FontAwesomeIcon className="text-xs text-gray-500" icon={faChevronDown} />
                  </button>
                  {showFormatFilter && (
                    <div className="absolute right-0 z-50 mt-2 w-52 origin-top-right overflow-hidden rounded-xl border border-gray-200 bg-white py-1 shadow-2xl dark:border-white/10 dark:bg-[#171717]">
                      {formatOptions.map((format) => (
                        <button
                          key={format.value}
                          type="button"
                          onClick={() => handleFormatChange(format.value)}
                          className="flex w-full items-center justify-between px-4 py-2.5 text-sm text-gray-700 transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10"
                        >
                          <span>{format.name}</span>
                          {selectedFormats.includes(format.value) && (
                            <FontAwesomeIcon icon={faCheck} className="text-sm text-orange-500" />
                          )}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <Menu as="div" className="relative">
                  <Menu.Button className="flex h-[52px] min-w-[182px] items-center justify-between gap-3 rounded-2xl border border-gray-200 bg-white px-4 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none dark:border-white/10 dark:bg-white/[0.045] dark:text-gray-200 dark:hover:bg-white/[0.08]">
                    {filtersText}
                    <FontAwesomeIcon className="text-xs text-gray-500" icon={faChevronDown} />
                  </Menu.Button>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-50 mt-2 w-52 origin-top-right overflow-hidden rounded-xl border border-gray-200 bg-white py-1 shadow-2xl focus:outline-none dark:border-white/10 dark:bg-[#171717]">
                      {filterDropDown.map((item) => (
                        <Menu.Item key={item.name}>
                          {({ active }) => (
                            <button
                              type="button"
                              onClick={() => handleFilterText(item.name)}
                              className={`block w-full px-4 py-2.5 text-left text-sm ${active ? "bg-gray-100 text-gray-950 dark:bg-white/10 dark:text-white" : "text-gray-700 dark:text-gray-300"}`}
                            >
                              {item.name}
                            </button>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Transition>
                </Menu>

                <button
                  type="button"
                  onClick={() => setShowCopy((current) => !current)}
                  className={`flex h-[52px] items-center gap-2 rounded-2xl border px-4 text-sm font-semibold transition-colors ${showCopy
                    ? "border-gray-300 bg-gray-100 text-gray-950 dark:border-white/10 dark:bg-white/10 dark:text-white"
                    : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50 dark:border-white/10 dark:bg-white/[0.045] dark:text-gray-400 dark:hover:bg-white/[0.08]"
                    }`}
                  aria-pressed={showCopy}
                >
                  {showCopy ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
                  Show Copy
                </button>
              </div>
            </div>

            <div className="subbucketheaderdesktop-section !hidden">
              <div className="cards-filter cardsspacing-content pt-[26px] flex justify-between">
                <div className="flex items-center">
                  <div className="card-count flex items-center">
                    <h4 className="cardssubBuckets-content">Cards</h4>
                    <span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">
                      {totalCards}
                    </span>
                  </div>
                  <Menu as="div" className="relative px-2">
                    <Menu.Button className="relative ml-3 inline-flex items-center px-1 py-2 text-sm font-semibold text-gray-900 ">
                      {/* <FontAwesomeIcon className="text-lg text-[#707070]" icon={faEllipsisVertical} /> */}
                      <img
                        className="threedots-content"
                        src={ThreeDots}
                        alt="threeDots"
                      />
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        {bucketNav.map((item) => (
                          <Menu.Item key={item.name}>
                            {({ active }) => (
                              <a
                                href={item.href}
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block py-2 px-4 text-sm text-gray-700"
                                )}
                                onClick={() => {
                                  handleCardClick(item.name);
                                }}
                              >
                                <span className="pr-2">
                                  <FontAwesomeIcon
                                    className="text-[#797979]"
                                    icon={item.icon}
                                  />
                                </span>
                                <span className="text-black">{item.name}</span>
                              </a>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                  <Transition appear show={false} as={Fragment}>
                    <Dialog
                      as="div"
                      className="relative z-10"
                      onClose={closeCardModal}
                    >
                      <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                      </Transition.Child>

                      <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                          <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                          >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                              <Dialog.Title
                                as="h3"
                                className="text-lg font-medium leading-6 text-gray-900"
                              >
                                Delete
                              </Dialog.Title>
                              <div className="mt-2">
                                <p className="text-sm text-gray-500">
                                  Are you sure you want to delete?
                                </p>
                              </div>

                              <div className="mt-4">
                                <button
                                  style={{
                                    background: "#FF6600",
                                    width: "80px",
                                    color: "#fff",
                                    padding: "10px",
                                    borderRadius: "50px",
                                  }}
                                  type="button"
                                  className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                  onClick={() => handleDeleteCard()}
                                >
                                  Yes
                                </button>
                                <button
                                  style={{
                                    background: "#000",
                                    width: "80px",
                                    color: "#fff",
                                    padding: "10px",
                                    borderRadius: "50px",
                                  }}
                                  type="button"
                                  className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                  onClick={closeCardModal}
                                >
                                  No
                                </button>
                              </div>
                            </Dialog.Panel>
                          </Transition.Child>
                        </div>
                      </div>
                    </Dialog>
                  </Transition>
                  {/* <FontAwesomeIcon className="transform rotate-45 px-3" icon={faArrowUp } /> */}
                  <img src={Arrow} alt="arrow" className="px-3" onClick={MoveCard} />
                </div>
                <div className="flex">
                  <div className="filterHolder flex items-center justify-end">
                    {/* <div className="filter display-content"> 
                            <a className="viewGrid" href={getUrl('list')}>                            
                             <img className="mt-1 listcard-imgcontent" src={ListView} alt="listView" />
                            </a>
                            <a className="viewGrid" href={getUrl('grid')}>                            
                             <img className="mt-1 compact-imgcontent" src={compactCardIcon} style={{color:'#000000'}} alt="compactIcon" />
                            </a>
                        </div> */}
                    {/* Platform Filter */}
                    <div className="platform-filter relative flex-shrink-0 mr-3">
                      <button
                        onClick={handlePlatformFilterClick}
                        className="flex rounded-full focus:outline-none"
                      >
                        <span data-former-link=""

                          className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                        >
                          <strong className="createdtext-content pr-4">
                            Platform ({selectedPlatforms.length})
                          </strong>
                          <FontAwesomeIcon
                            style={{ fontSize: "12px", color: "#707070" }}
                            icon={faChevronDown}
                          />
                        </span>
                      </button>
                      {showPlatformFilter && (
                        <div className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <div className="px-4 py-2 border-b border-gray-200 hidden">
                            <div className="flex justify-between items-center">
                              <span className="text-sm font-medium text-gray-700">Platforms</span>
                              <div className="flex space-x-2">
                                <button
                                  onClick={handleSelectAllPlatforms}
                                  className="text-xs text-blue-600 hover:text-blue-800"
                                >
                                  All
                                </button>
                                <button
                                  onClick={handleUnselectAllPlatforms}
                                  className="text-xs text-red-600 hover:text-red-800"
                                >
                                  None
                                </button>
                              </div>
                            </div>
                          </div>
                          {platformOptions.map((platform) => (
                            <div key={platform.value}>
                              <button
                                onClick={() => handlePlatformChange(platform.value)}
                                className={classNames(
                                  "w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                                )}
                              >
                                <span>{platform.name}</span>
                                {selectedPlatforms.includes(platform.value) && (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    className="text-blue-600 text-sm"
                                  />
                                )}
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Format Filter */}
                    <div className="format-filter relative flex-shrink-0 mr-3">
                      <button
                        onClick={handleFormatFilterClick}
                        className="flex rounded-full focus:outline-none"
                      >
                        <span data-former-link=""

                          className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                        >
                          <strong className="createdtext-content pr-4">
                            Format ({selectedFormats.length})
                          </strong>
                          <FontAwesomeIcon
                            style={{ fontSize: "12px", color: "#707070" }}
                            icon={faChevronDown}
                          />
                        </span>
                      </button>
                      {showFormatFilter && (
                        <div className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <div className="px-4 py-2 border-b border-gray-200 hidden">
                            <div className="flex justify-between items-center">
                              <span className="text-sm font-medium text-gray-700">Formats</span>
                              <div className="flex space-x-2">
                                <button
                                  onClick={handleSelectAllFormats}
                                  className="text-xs text-blue-600 hover:text-blue-800"
                                >
                                  All
                                </button>
                                <button
                                  onClick={handleUnselectAllFormats}
                                  className="text-xs text-red-600 hover:text-red-800"
                                >
                                  None
                                </button>
                              </div>
                            </div>
                          </div>
                          {formatOptions.map((format) => (
                            <div key={format.value}>
                              <button
                                onClick={() => handleFormatChange(format.value)}
                                className={classNames(
                                  "w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                                )}
                              >
                                <span>{format.name}</span>
                                {selectedFormats.includes(format.value) && (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    className="text-blue-600 text-sm"
                                  />
                                )}
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <span className="sorttext-content mx-3 dark:text-[#acacac]">
                      Sort By
                    </span>
                    <Menu as="div" className="relative flex-shrink-0">
                      <div>
                        <Menu.Button className="flex rounded-full focus:outline-none ">
                          <span data-former-link=""

                            className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                          >
                            <strong className="createdtext-content pr-4">
                              {filtersText}
                            </strong>
                            <FontAwesomeIcon
                              style={{ fontSize: "12px", color: "#707070" }}
                              icon={faChevronDown}
                            />
                          </span>
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {filterDropDown.map((item) => (
                            <Menu.Item key={item.name}>
                              {({ active }) => (
                                <a
                                  onClick={() => {
                                    handleFilterText(item.name);
                                  }}
                                  href={item.href}
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block py-2 px-4 text-sm text-gray-700"
                                  )}
                                >
                                  {item.name}
                                </a>
                              )}
                            </Menu.Item>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>
              </div>
            </div>
            <div className="subbucketheadermbl-section !hidden">
              <div className="cards-filter cardsspacing-content pt-[30px] flex justify-between">
                <div className="flex items-center">
                  <div className="card-count flex items-center">
                    <h4 className="cardssubBuckets-content">Cards</h4>
                    <span className="subbucketsbg-content background-primary text-white rounded-full ml-4 text-[16px]">
                      {totalCards}
                    </span>
                  </div>
                  <Menu as="div" className="relative px-2">
                    <Menu.Button className="relative ml-3 inline-flex items-center px-1 py-2 text-sm font-semibold text-gray-900 ">
                      {/* <FontAwesomeIcon className="text-lg text-[#707070]" icon={faEllipsisVertical} /> */}
                      <img
                        className="threedots-content"
                        src={ThreeDots}
                        alt="threeDots"
                      />
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        {bucketNav.map((item) => (
                          <Menu.Item key={item.name}>
                            {({ active }) => (
                              <a
                                href={item.href}
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block py-2 px-4 text-sm text-gray-700"
                                )}
                                onClick={() => {
                                  handleCardClick(item.name);
                                }}
                              >
                                <span className="pr-2">
                                  <FontAwesomeIcon
                                    className="text-[#797979]"
                                    icon={item.icon}
                                  />
                                </span>
                                <span className="text-black">{item.name}</span>
                              </a>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                  <Transition appear show={false} as={Fragment}>
                    <Dialog
                      as="div"
                      className="relative z-10"
                      onClose={closeCardModal}
                    >
                      <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                      </Transition.Child>

                      <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                          <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                          >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                              <Dialog.Title
                                as="h3"
                                className="text-lg font-medium leading-6 text-gray-900"
                              >
                                Delete
                              </Dialog.Title>
                              <div className="mt-2">
                                <p className="text-sm text-gray-500">
                                  Are you sure you want to delete?
                                </p>
                              </div>

                              <div className="mt-4">
                                <button
                                  style={{
                                    background: "#FF6600",
                                    width: "80px",
                                    color: "#fff",
                                    padding: "10px",
                                    borderRadius: "50px",
                                  }}
                                  type="button"
                                  className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                  onClick={() => handleDeleteCard()}
                                >
                                  Yes
                                </button>
                                <button
                                  style={{
                                    background: "#000",
                                    width: "80px",
                                    color: "#fff",
                                    padding: "10px",
                                    borderRadius: "50px",
                                  }}
                                  type="button"
                                  className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                  onClick={closeCardModal}
                                >
                                  No
                                </button>
                              </div>
                            </Dialog.Panel>
                          </Transition.Child>
                        </div>
                      </div>
                    </Dialog>
                  </Transition>
                  {/* <FontAwesomeIcon className="transform rotate-45 px-3" icon={faArrowUp } /> */}
                  <img src={Arrow} alt="arrow" className="px-3" />
                </div>
                <div className="flex">
                  <div className="filterHolder flex items-center justify-end">
                    {/* <div className="filter display-content"> 
                            <a className="viewGrid" href={getUrl('list')}>                            
                             <img className="mt-1 listcard-imgcontent" src={ListView} alt="listView" />
                            </a>
                            <a className="viewGrid" href={getUrl('grid')}>                            
                             <img className="mt-1 compact-imgcontent" src={compactCardIcon} style={{color:'#000000'}} alt="compactIcon" />
                            </a>
                        </div> */}

                    {/* Platform Filter Mobile */}
                    <div className="platform-filter relative flex-shrink-0 mr-2">
                      <button
                        onClick={handlePlatformFilterClick}
                        className="flex rounded-full dark:text-[#acacac] focus:outline-none"
                      >
                        <span data-former-link=""

                          className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                        >
                          <span className="text-xs font-medium">
                            P ({selectedPlatforms.length})
                          </span>
                        </span>
                      </button>
                      {showPlatformFilter && (
                        <div className="filter-dropdown dropdownmbl-content absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <div className="px-3 py-2 border-b border-gray-200 hidden">
                            <div className="flex justify-between items-center">
                              <span className="text-xs font-medium text-gray-700">Platforms</span>
                              <div className="flex space-x-1">
                                <button
                                  onClick={handleSelectAllPlatforms}
                                  className="text-xs text-blue-600 hover:text-blue-800"
                                >
                                  All
                                </button>
                                <button
                                  onClick={handleUnselectAllPlatforms}
                                  className="text-xs text-red-600 hover:text-red-800"
                                >
                                  None
                                </button>
                              </div>
                            </div>
                          </div>
                          {platformOptions.map((platform) => (
                            <div key={platform.value}>
                              <button
                                onClick={() => handlePlatformChange(platform.value)}
                                className={classNames(
                                  "w-full flex items-center justify-between px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer"
                                )}
                              >
                                <span>{platform.name}</span>
                                {selectedPlatforms.includes(platform.value) && (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    className="text-blue-600 text-xs"
                                  />
                                )}
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Format Filter Mobile */}
                    <div className="format-filter relative flex-shrink-0 mr-2">
                      <button
                        onClick={handleFormatFilterClick}
                        className="flex rounded-full dark:text-[#acacac] focus:outline-none"
                      >
                        <span data-former-link=""

                          className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500"
                        >
                          <span className="text-xs font-medium">
                            F ({selectedFormats.length})
                          </span>
                        </span>
                      </button>
                      {showFormatFilter && (
                        <div className="filter-dropdown dropdownmbl-content absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <div className="px-3 py-2 border-b border-gray-200 hidden">
                            <div className="flex justify-between items-center">
                              <span className="text-xs font-medium text-gray-700">Formats</span>
                              <div className="flex space-x-1">
                                <button
                                  onClick={handleSelectAllFormats}
                                  className="text-xs text-blue-600 hover:text-blue-800"
                                >
                                  All
                                </button>
                                <button
                                  onClick={handleUnselectAllFormats}
                                  className="text-xs text-red-600 hover:text-red-800"
                                >
                                  None
                                </button>
                              </div>
                            </div>
                          </div>
                          {formatOptions.map((format) => (
                            <div key={format.value}>
                              <button
                                onClick={() => handleFormatChange(format.value)}
                                className={classNames(
                                  "w-full flex items-center justify-between px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer"
                                )}
                              >
                                <span>{format.name}</span>
                                {selectedFormats.includes(format.value) && (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    className="text-blue-600 text-xs"
                                  />
                                )}
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div>
                      <Menu
                        as="div"
                        className="sortmbl-content relative flex-shrink-0"
                      >
                        <div>
                          <Menu.Button className="flex rounded-full dark:text-[#acacac] focus:outline-none">
                            <span data-former-link=""

                              className="flex-shrink-0 rounded-full text-gray-400 hover:text-gray-500 "
                            >
                              <img src={SortMbl} alt="SortMbl" />
                            </span>
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="filter-dropdown dropdownmbl-content absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            {filterDropDown.map((item) => (
                              <Menu.Item key={item.name}>
                                {({ active }) => (
                                  <a
                                    onClick={() => {
                                      handleFilterText(item.name);
                                    }}
                                    href={item.href}
                                    className={classNames(
                                      active ? "bg-gray-100" : "",
                                      "block py-2 px-4 text-sm text-gray-700"
                                    )}
                                  >
                                    {item.name}
                                  </a>
                                )}
                              </Menu.Item>
                            ))}
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {selectedItems.length > 0 && (
            <div
              className={`mb-6 rounded-2xl border p-4 flex flex-wrap items-center justify-between gap-3 backdrop-blur-sm ${
                appTheme === "dark"
                  ? "border-orange-500/30 bg-orange-500/10"
                  : "border-orange-200 bg-orange-50"
              }`}
            >
              <div className="flex flex-wrap items-center gap-3">
                <span
                  className={`text-sm font-semibold ${
                    appTheme === "dark" ? "text-white" : "text-gray-900"
                  }`}
                >
                  {selectedItems.length} card
                  {selectedItems.length !== 1 ? "s" : ""} selected
                </span>
                <button
                  type="button"
                  className={`h-8 rounded-lg px-3 text-sm transition-colors ${
                    appTheme === "dark"
                      ? "text-gray-400 hover:bg-white/5 hover:text-white"
                      : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                  }`}
                  onClick={() => setSelectedItems([])}
                >
                  Clear selection
                </button>
              </div>
              <button
                type="button"
                className="h-8 rounded-lg bg-red-600 px-4 text-sm font-semibold text-white transition-colors hover:bg-red-700"
                onClick={deleteCard}
              >
                Delete selected
              </button>
            </div>
          )}

          <Transition appear show={isOpenss} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={closeCardModal}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black bg-opacity-25" />
              </Transition.Child>
              <div className="fixed inset-0 overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-medium leading-6 text-gray-900"
                      >
                        Delete
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          Are you sure you want to delete?
                        </p>
                      </div>
                      <div className="mt-4">
                        <button
                          type="button"
                          style={{
                            background: "#FF6600",
                            width: "80px",
                            color: "#fff",
                            padding: "10px",
                            borderRadius: "50px",
                          }}
                          className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium"
                          onClick={handleDeleteCard}
                        >
                          Yes
                        </button>
                        <button
                          type="button"
                          style={{
                            background: "#000",
                            width: "80px",
                            color: "#fff",
                            padding: "10px",
                            borderRadius: "50px",
                          }}
                          className="ml-4 inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium"
                          onClick={closeCardModal}
                        >
                          No
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>

          {/* Single Card cardsgap-content flex flex-wrap  md:masonry-2-col lg:masonry-4-col mt-5*/}
          {/* New Single Card Grid */}
          <div className="mansorydesktop-section">
            <ResponsiveMasonry
              breakpointCols={cardGridBreakpoints}
              className="card-masonry flex -ml-4 w-auto"
              columnClassName="card-masonry__column pl-4 bg-clip-padding"
            >
              {(visibleCards || []).map((card) => {
                const sharedWithObjects = card?.shared
                  ? card.shared
                    .filter(shares => isPresent(shares.sharedWith))
                    .map(shares => shares.sharedWith)
                  : [];
                return (
                  <div key={card._id} className="w-full inline-block break-inside-avoid mb-[-3px]" style={{ contain: "inline-size" }}>
                    <NewSingleCard
                      selectedItems={selectedItems}
                      PermissionState={PermissionState}
                      handleSharePop={handleCardSharePop}
                      SharedToken={SharedToken}
                      sharedBy={[]}
                      sharedUsers={sharedWithObjects}
                      shared={card?.shared}
                      starred={card.starred}
                      buckets={buckets}
                      cardUpdate={cardUpdate}
                      cardId={card._id}
                      cardType={card.cardType}
                      sharedLength={card.shared?.length || 0}
                      title={card.title}
                      content={card.content}
                      note={card.note}
                      tags={card.tags}
                      postDetail={card.postDetail ? card.postDetail : ""}
                      updated={card.updatedAt}
                      handleCheckboxChange={handleCheckboxChange}
                      adData={card.adData}
                      aiData={card.content?.extractedData || null}
                      showCopy={showCopy}
                    />
                  </div>
                );
              })}
            </ResponsiveMasonry>
          </div>
          {!isLoadings && visibleCards.length === 0 && (
            <div className="bucket-cards-empty" role="status">
              <h3>{hasActiveCardFilters ? "No matching cards" : "No cards in this bucket yet"}</h3>
              <p>{hasActiveCardFilters ? "Try another search or clear the current filters." : "Cards saved to this bucket will appear here."}</p>
            </div>
          )}
          {isLoadings && <CardSkeletonGrid />}
        </div>
      )}
      {CardSharePopup && (
        <div
          className="filesuploadpopup relative !z-[999]"
          style={{ height: "100%" }}
          onClick={closeCardSharePop}
        >
          <div
            className="subinviteupload-section"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="teaminvitesection flex">
              <div className="teammembers-content">
                Share
              </div>
              <div
                className="dismissSubfiles-content"
                onClick={closeCardSharePop}
              >
                <img
                  src={BlackDismiss}
                  alt="dismissButton"
                />
              </div>
            </div>
            <ShareCard
              shareBucketId={shareCardId}
              closeSharePop={closeCardSharePop}
              cardsRefresh={cardUpdate}
            />
          </div>
        </div>
      )}
      {popup === true ? (
        <CreateBucket
          bucketUpdate={bucketUpdate}
          cardUpdate={cardUpdate}
          changeTxt={changeTxt}
          bucketOperation={bucketOperation}
          bucketNameText={bucketNameText}
          bucketUpdateId={bucketUpdateId}
          parent={bucketId.id}
          setPopup={setPopup}
        />
      ) : null}
      {moveModal ? <MoveModal openMove={openMove} closeModal={closeMove} selectedItems={selectedItems} cardUpdate={cardUpdate} buckets={buckets} /> : null}
      <Transition appear show={openCopyLink} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={closeCopyLinkModal}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all text-center">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Copy and Paste this URL
                  </Dialog.Title>
                  <div
                    style={{ display: "block" }}
                    className="custom-list-dropdown"
                  >
                    <div className="position-relative">
                      <input
                        type="text"
                        placeholder="URL"
                        value={publicUrl}
                        className="publicUrlInput"
                      // onChange={handleFileInput}
                      />
                    </div>
                    <div className="flex justify-end">
                      <div
                        className="cancelfilecard-content"
                        onClick={closeCopyLinkModal}
                      >
                        Cancel
                      </div>
                      <button
                        style={{
                          filter:
                            "drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))",
                        }}
                        className="buttonpadding-content text-[16px] rounded-full bg-[#FF6600] text-white"
                        onClick={() => handleCopyText(publicUrl)}
                      >
                        <span className="savebutton-context">Copy</span>
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <ScrollToTop smooth color="#fff" component={<MySVG />} />
      <ToastContainer />
    </>
  );
}

export default BucketInner;
